import type {
  ConversionEvent,
  GtagEventName,
  GtagEventParameters,
  CalculatorMetadata,
} from "$lib/types/landing"
import { browser } from "$app/environment"

declare global {
  interface Window {
    gtag?: (
      command: string,
      eventName: GtagEventName,
      parameters?: GtagEventParameters,
    ) => void
  }
}

export function trackConversion(event: ConversionEvent) {
  if (!browser) return

  // Google Analytics 4
  if (window.gtag) {
    window.gtag("event", event.type, {
      audience: event.audience,
      value: event.value,
      custom_parameters: event.metadata,
    })
  }

  // Custom analytics endpoint (future implementation)
  try {
    fetch("/api/analytics", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(event),
    }).catch((err) => console.warn("Analytics tracking failed:", err))
  } catch (err) {
    console.warn("Analytics tracking failed:", err)
  }
}

export function trackPageView(audience: string, page: string = "landing") {
  trackConversion({
    type: "pricing_view",
    audience: audience as "students" | "universities",
    metadata: { page },
  })
}

export function trackCalculatorUsage(
  audience: "students" | "universities",
  data: CalculatorMetadata,
) {
  trackConversion({
    type: "calculator_use",
    audience,
    metadata: data,
  })
}

export function trackDemoRequest(audience: "students" | "universities") {
  trackConversion({
    type: "demo_request",
    audience,
    value: audience === "students" ? 99 : 999,
  })
}
